import React from 'react';
import { connect } from 'react-redux';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { FlagIcon } from 'apps/auth/components/common/FlagIcon/FlagIcon';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, IconWrapper, PanelFrame } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_GA_ACCOUNTS, AUTH_GA_POCKET, AUTH_REQUEST_CREATE } from 'apps/auth/constants/UrlConstants';
import { formatMoney } from 'apps/auth/helpers/formats';
import { toLowerCase } from 'apps/auth/helpers/utils';

import LibrePocketCardList from './LibrePocketCardList';

const LibrePocket = (props) => {
    const RequestMoneyButton = () => {
        return (
            <Panel type="link" href={AUTH_REQUEST_CREATE} isHoverable negativeMargin>
                <PanelFrame>
                    <DiskBadgeWrapper>
                        <DiskBadge iconName="arrow-down-left" variant="secondary" />
                    </DiskBadgeWrapper>
                    <Text color="primary">{props.requestMoneyButton}</Text>
                </PanelFrame>
            </Panel>
        );
    };

    return (
        <CommonPage backUrl={AUTH_GA_ACCOUNTS}>
            <Row indent="24px">
                <Row indent="16px">
                    <FlagIcon name={toLowerCase(props.pocketCurrencyCode)} size="large" />
                </Row>
                <Text indent="4px" variant="div">
                    {props.pocketCurrencyTitle}
                </Text>
                <Text size="display1" variant="div">
                    {formatMoney(props.accountBalance)}{' '}
                    <Text size="display1" smallCaps>
                        {toLowerCase(props.pocketCurrencyCode)}
                    </Text>
                </Text>
            </Row>
            {RequestMoneyButton()}
            <Separator marginTop="16px" />
            <LibrePocketCardList />
            <Panel type="reactLink" to={`${AUTH_GA_POCKET}${props.accountId}/activity`} hasIcon isHoverable negativeMargin>
                <IconWrapper>
                    <Icon name="list-marked" color="primary" />
                </IconWrapper>
                <Text>{props.accountActivity}</Text>
            </Panel>
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        accountBalance: state.extra?.account?.balance,
        accountId: state.extra?.account?.id,
        pocketCurrencyCode: state.extra?.account?.pocketCurrency?.code,
        pocketCurrencyTitle: state.extra?.account?.pocketCurrency?.title,
        requestMoneyButton: state.messages.pageMessages.requestMoneyButton,
        accountActivity: state.messages.pageMessages.accountActivity,
    };
};
export default connect(mapStateToProps)(LibrePocket);
